/***
**Module Name: header
 **File Name :  header.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains header details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import * as Config from "../../constants/Config";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import logo from '../../assets/images/logo.jpg'
import { contentContext } from "../../context/contentContext";

const Header = ({ fn }) => {

    const history = useHistory();
    const [image, setImg] = useState('');
    const [data, setData] = useState("");
    const [userName, setUserName] = useState([]);

    const { setShowPopup, setSelectedOptions, setMultiSelectFields, setActiveFieldsObj, setActiveMenuObj,
        setSelectedOptionsClientName, setSearchPayload, setInitialCategoriesData1, toggleMenu, setToggleMenu, GetTimeActivity,userData, setUserData} = useContext(contentContext)

    const handleProfile = (e) => {
        // GetTimeActivity();
        history.push("/admin/profile");
    }

    const handleLogout = (e) => {
        // GetTimeActivity();
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        signoutsession();
        history.push("/admin");


    }

    // console.log('user edataaa',userData)
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }


    }, [window.site]);

    // useEffect(() => {

    //     GetUserData();

    // }, []);

    useEffect(() => {
        // userName = localStorage.getItem("ClientName")?.split(" ");

        // if(userData == undefined){
        //     // setShowSessionPopupup(true)
        //     localStorage.clear()
        //     history.push("/")
        // }else {
            setUserName(userData?.name?.split(" "));
       // }
       


    }, [userData]);

    // const GetUserData = async () => {
    //     try {

    //         const response = await tmdbApi.getUserData();

    //         if (response?.statusCode === 200) {

    //             setUserData(response?.result?.[0]);

    //         }
    //     } catch {
    //         console.log("error");
    //     }
    // };

    const signoutsession = async () => {
        try {
            const response = await tmdbApi.SignOutUser({ emailId: userData.emailid });
            console.log(response);

        } catch {
            console.log("error");
        }
    }
    const handleRedirect = () => {
        // GetTimeActivity();
        // let userArr = userData.permissions

        // console.log("userArr", userData)

        // const obj = userArr.reduce((acc, item) => {
        //     if (item.submenus) acc[item.menu] = false;
        //     return acc;
        // }, {});
        // // console.log('objjjjjjjj--->',obj)

        // let k = userData

        // let permissionList = userData && userData.permissions
        // let filterdList = permissionList.filter((item) => item.display == true)
        // let id = filterdList && filterdList[0] && filterdList[0].menu.split(" ").join("").toLowerCase()

        history.push("/admin");
    }

    //   let userName=[]
    //   userName = localStorage.getItem("ClientName")?.split(" ");

    const handleMenuToggle = () => {
        setToggleMenu(!toggleMenu)
    }

    return (
        <>
        {/* {showSessionPopupup && <SessionPopup />} */}
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                    <button type="button" className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                            id="vertical-menu-btn" onClick={handleMenuToggle}>
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                        <div className="navbar-brand-box">


                            <a onClick={handleRedirect} className="logo">
                                <span className="logo-lg">
                                    <img src={logo} />
                                </span>
                                <h4>Dermatopathology Society of India</h4>
                            </a>
                        </div>

                    


                        {/* <form className="app-search d-none d-lg-block">
                            <div className="position-relative">
                                <input type="text" className="form-control" placeholder="Search..." />
                                <span className="bx bx-search-alt"></span>
                            </div>
                        </form> */}


                    </div>

                    <div className="d-flex profile_section">

                        <div className="dropdown d-inline-block d-lg-none ms-2">
                           
                        </div>

                        <div className="dropdown d-inline-block">

                           
                        </div>

                        <div className="dropdown d-inline-block">
                            <button type="button" className="btn header-item waves-effect" id="page-header-user-dropdown"
                                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">


                                <span className="user-badge">{userName && userName.length > 1 ? userName && userName.length > 0 && userName[0]?.slice(0, 1)?.toUpperCase() + userName[1]?.slice(0, 1)?.toUpperCase()
                                    : userData && userData.name?.slice(0, 2)?.toUpperCase()}</span>


                                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">

                                <a className="dropdown-item" onClick={handleProfile}><i className="bx bx-user font-size-16 align-middle me-1"></i>
                                    <span key="t-profile">Profile</span></a>

                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item text-danger" onClick={handleLogout}><i
                                    className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                                        key="t-logout">Logout</span></a>
                            </div>
                        </div>

                    </div>
                </div>
            </header>


        </>
    );
};

export default Header;
